module.exports = __webpack_public_path__ + "img/icn-slot-checked.10e0259b.png";